import React from 'react';
import { Container, Title, Text, Button, Stack, Paper } from '@mantine/core';
import { useNavigate } from 'react-router-dom';

/**
 * NotFound - 404 page for unknown routes
 */
export const NotFound: React.FC = (): React.ReactElement => {
  const navigate = useNavigate();

  const handleGoHome = (): void => {
    navigate('/');
  };

  return (
    <Container size="sm" mt="4rem">
      <Paper shadow="md" radius="md" p="xl">
        <Stack align="center" gap="lg">
          <Title order={1} fz="4rem">
            404
          </Title>

          <Title order={2}>Page Not Found</Title>

          <Text c="dimmed" ta="center">
            The page you are looking for does not exist. It may have been moved or deleted.
          </Text>

          <Button onClick={handleGoHome} size="lg">
            Go Home
          </Button>
        </Stack>
      </Paper>
    </Container>
  );
};
